import { Link, SvgIcon, Typography } from "@mui/material";
import { Link as RouterLink, useMatch } from "react-router-dom";

type BreadcrumbProps = {
  to?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { to, icon, children } = props;

  const isLink = !!to;
  const isLastSegment = !!useMatch({ path: to || "", end: true });

  if (!isLink || isLastSegment) {
    return (
      <Typography
        component="span"
        sx={{ display: "flex", alignItems: "center", gap: 0.5, p: 1 }}
      >
        {icon && <SvgIcon fontSize="small">{icon}</SvgIcon>}

        {children}
      </Typography>
    );
  }

  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      sx={{ display: "flex", alignItems: "center", gap: 0.5, p: 1 }}
    >
      {icon && <SvgIcon fontSize="small">{icon}</SvgIcon>}

      {children}
    </Link>
  );
};

export default Breadcrumb;
